import React from 'react';
import Svg, { Path } from 'react-native-svg';

const DotIcon = ({ fill }: { fill?: string }) => {
  return (
    <Svg width="16" height="17" viewBox="0 0 16 17" fill="none">
      <Path
        d="M7.99992 5.72656C7.29267 5.72656 6.6144 6.00751 6.1143 6.50761C5.6142 7.00771 5.33325 7.68599 5.33325 8.39323C5.33325 9.10047 5.6142 9.77875 6.1143 10.2788C6.6144 10.7789 7.29267 11.0599 7.99992 11.0599C8.70716 11.0599 9.38544 10.7789 9.88554 10.2788C10.3856 9.77875 10.6666 9.10047 10.6666 8.39323C10.6666 7.68599 10.3856 7.00771 9.88554 6.50761C9.38544 6.00751 8.70716 5.72656 7.99992 5.72656Z"
        fill={fill || 'white'}
      />
    </Svg>
  );
};

export default DotIcon;
